import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import  { useState } from "react";

import Close from '@mui/icons-material/Close';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';

const AttendanceActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess, title, callback }) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);
        handlecallProcess(buttonName);
    };

    return (

        <Grid container justifyContent="space-between" alignItems="center" padding={0}>
            {/* Left-aligned: Edit Employee */}
            <Grid item>
                <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                    {title}
                </Typography>
            </Grid>

            {/* Right-aligned: Buttons */}
            <Grid item>
                <Grid container alignItems="center">
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    {/* Save */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title="Add new orders">
                            <IconButton
                                onClick={() => handleButtonClick('save')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                                type="submit"
                            // disabled={saveButtonDisabled}
                            >
                                <SaveAltIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>Save</Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    {/* Exit Employee */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title="Clear Field Detail">
                            <IconButton
                                onClick={() => handleButtonClick('clear')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <RemoveCircleOutlineOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'clear' ? "yellow" : "#009688" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>Clear</Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    {/* Exit Employee */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title="View Monthly Report for Employee">
                            <IconButton
                                onClick={() => handleButtonClick('report')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <SummarizeOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'report' ? "yellow" : "#009688" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>View Monthly Attendance</Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <IconButton onClick={callback}>                        
                        <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                    </IconButton>
                    <Divider orientation="vertical" flexItem
                    
                    />
                </Grid>
            </Grid>
        </Grid>


    )
};
export default AttendanceActionMenu;